import { forwardRef, type Ref, type SVGProps } from "react";
const IconReplyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26.56 14.85A12.25 12.25 0 0 0 18 12H5.414l6.293-6.293a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 0 1.414l8 8a1 1 0 0 0 1.414-1.414L5.414 14h12.669c.046 0 4.26-.313 7.139 2.339C27.065 18.035 28 20.614 28 24v3a1 1 0 1 0 2 0v-3c0-3.978-1.157-7.056-3.44-9.15"
    />
  </svg>
);
const ForwardRef = forwardRef(IconReplyOutlineSVG);
ForwardRef.displayName = "IconReplyOutline";
export { ForwardRef as IconReplyOutline };
